import { useQuery } from "@tanstack/react-query";
import { getQueryAnswerUsedDocuments } from "./getSourceRefs";

export const useQueryAnswerDocuments = ({ qid }: { qid: string }) => {
  const query = useQuery({
    queryKey: ["queryAnswerDocuments", qid],
    queryFn: async () => {
      const data = await getQueryAnswerUsedDocuments(qid);
      return data;
    },
    enabled: !!qid,
  });

  return query;
};
